import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { ApiResponse, OrderModel, OrderCriteria, SupplierOrderCriteria, AssignOrderDriverDto, OrderStatusUpdateDto } from '../objects';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';

@Injectable()
export class OrderService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    insertOrder(model: OrderModel, headers?: HttpHeaders) {
        const endpoint = '/api/v1/order';
        return this.post(endpoint, model, headers);
    }

    getByCriteria(criteria: OrderCriteria, headers?: HttpHeaders) {
        let endpoint = '/api/v1/order';
        endpoint = `${endpoint}?referenceNo=${criteria.referenceNo ? criteria.referenceNo : ''}`;
        if (criteria.mobileNumber) {
            endpoint = `${endpoint}&mobileNumber=${criteria.mobileNumber}`;
        }
        if (criteria.orderDate) {
            endpoint = `${endpoint}&orderDate=${criteria.orderDate}`;
        }
        if (criteria.orderId) {
            endpoint = `${endpoint}&orderId=${criteria.orderId}`;
        }
        if (criteria.orderStatus) {
            endpoint = `${endpoint}&orderStatus=${criteria.orderStatus}`;
        }
        if (criteria.username) {
            endpoint = `${endpoint}&username=${criteria.username}`;
        }
        endpoint = `${endpoint}&pageIndex=${criteria.pageIndex ? criteria.pageIndex : ''}&pageSize=${criteria.pageSize ? criteria.pageSize : ''}`;

        return this.getAll(endpoint, headers);
    }

    getDriverOrders(driverId: number, pageIndex?: number, pageSize?: number) {
        let endpoint = '/api/v1/order/driver/' + driverId;
        if (pageIndex) {
            endpoint = `${endpoint}?pageIndex=${pageIndex}`;
        }
        if (pageSize) {
            endpoint = `${endpoint}?pageSize=${pageSize}`;
        }

        return this.getAll(endpoint);
    }

    getOrderStatus() {
        const endpoint = '/api/v1/order/order-status';
        return this.getAll(endpoint);
    }

    getSupplierOrderStatus() {
        const endpoint = '/api/v1/order/supp/order-status';
        return this.getAll(endpoint);
    }

    getSupplierOrderByCriteria(criteria: SupplierOrderCriteria, headers?: HttpHeaders) {
        let endpoint = `/api/v1/order/supp`;
        endpoint = `${endpoint}?referenceNo=${criteria.referenceNo ? criteria.referenceNo : ''}`;
        if (criteria.statusId) {
            endpoint = `${endpoint}&statusId=${criteria.statusId}`;
        }
        if (criteria.orderDate) {
            endpoint = `${endpoint}&orderDate=${criteria.orderDate}`;
        }
        endpoint = `${endpoint}&pageIndex=${criteria.pageIndex ? criteria.pageIndex : ''}&pageSize=${criteria.pageSize ? criteria.pageSize : ''}`;

        return this.getAll(endpoint, headers);
    }

    getSupplierOrderById(id: number, headers?: HttpHeaders) {
        const endpoint = `/api/v1/order/supp`;
        return this.getById(endpoint, id, headers);
    }

    assignOrder(dto: AssignOrderDriverDto, headers?: HttpHeaders) {
        const endpoint = '/api/v1/order/assign-order';
        return this.post(endpoint, dto, headers);
    }

    updateOrderStatus(dto: OrderStatusUpdateDto, headers?: HttpHeaders) {
        const endpoint = '/api/v1/order/order-status';
        return this.put(endpoint, dto, headers);
    }

    updateSuppOrderStatus(dto: OrderStatusUpdateDto, headers?: HttpHeaders) {
        const endpoint = '/api/v1/order/supp/order-status';
        return this.put(endpoint, dto, headers);
    }

    getOrderById(id: number, headers?: HttpHeaders) {
        const endpoint = '/api/v1/order';
        return this.getById(endpoint, id, headers);
    }

}
